var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Dropdown, CustomModal, Toast, useToast, Spinner } from '../../index';
import { languageCodeMapper } from "./languageCodes";
import './UserSettings.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateUserSetting, getRoles, changeUserRole } from '../../adapters/UserAdapter';
var UserSettings = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var lan = languageCodeMapper;
    var languageCode = Object.values(lan);
    var navigate = useNavigate();
    var getLanguageKey = function (list, value) {
        return Object.keys(list).find(function (key) { return list[key] === value; });
    };
    var userDetails = props.userDetails, setLoggedInProfileInfo = props.setLoggedInProfileInfo;
    var _g = useState(true), saveDisabled = _g[0], setSaveDisabled = _g[1];
    var _h = useToast(), toastQueue = _h.toastQueue, addToast = _h.addToast;
    var _j = useState({
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.email,
        role: userDetails.role,
        settings: {
            language: getLanguageKey(lan, (((_a = userDetails.settings) === null || _a === void 0 ? void 0 : _a.language) || 'en-GB')),
            unit: (((_b = userDetails.settings) === null || _b === void 0 ? void 0 : _b.unit) || 'Metric'),
        },
    }), settings = _j[0], setSettings = _j[1];
    var _k = useState(lan[(((_c = userDetails.settings) === null || _c === void 0 ? void 0 : _c.language) || 'en-GB')]), language = _k[0], setLanguage = _k[1];
    var _l = useState(userDetails.role), roles = _l[0], setRoles = _l[1];
    var _m = useState(((_d = userDetails.settings) === null || _d === void 0 ? void 0 : _d.unit) || 'Metric'), unit = _m[0], setUnit = _m[1];
    var _o = useState([]), roleList = _o[0], setRoleList = _o[1];
    var t = useTranslation().t;
    var newLoggedInProfileInfo = __assign({}, userDetails);
    var saveChanges = function () {
        setLoggedInProfileInfo(newLoggedInProfileInfo);
    };
    useEffect(function () {
        getRoles().then(function (response) {
            setRoleList(response.data);
        });
    }, []);
    useEffect(function () {
        var _a, _b;
        if ((unit !== (((_a = userDetails.settings) === null || _a === void 0 ? void 0 : _a.unit) || 'Metric') ||
            language !== lan[(((_b = userDetails.settings) === null || _b === void 0 ? void 0 : _b.language) || 'en-GB')] ||
            roles !== userDetails.role) && getLanguageKey(lan, language) !== undefined) {
            setSaveDisabled(false);
            setSettings(__assign(__assign({}, settings), { role: roles, settings: {
                    language: getLanguageKey(lan, language),
                    unit: unit
                } }));
        }
        else {
            setSaveDisabled(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language, roles, unit, lan]);
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(language !== lan[(((_a = userDetails.settings) === null || _a === void 0 ? void 0 : _a.language) || 'en-GB')])) return [3 /*break*/, 2];
                    // @ts-ignore
                    return [4 /*yield*/, updateUserSetting('language', settings.settings.language).then(function (response) {
                            newLoggedInProfileInfo.settings.language = getLanguageKey(lan, language);
                            addToast({ title: t('TS_core:NewLanguageSettingWasSaved'), text: '', type: 'success' });
                            var timeout = setTimeout(function () {
                                saveChanges();
                            }, 2200);
                            return function () { return clearTimeout(timeout); };
                        })
                            // @ts-ignore
                            .catch(function (error) {
                            addToast({ title: t('TS_core:NewLanguageSettingCouldNotBeSaved'), text: '', type: 'error' });
                        })];
                case 1:
                    // @ts-ignore
                    _d.sent();
                    _d.label = 2;
                case 2:
                    if (!(unit !== (((_b = userDetails.settings) === null || _b === void 0 ? void 0 : _b.unit) || 'Metric'))) return [3 /*break*/, 4];
                    // @ts-ignore
                    return [4 /*yield*/, updateUserSetting('unit', (_c = settings.settings) === null || _c === void 0 ? void 0 : _c.unit).then(function (response) {
                            newLoggedInProfileInfo.settings.unit = unit;
                            addToast({ title: t('TS_core:NewUnitSettingWasSaved'), text: '', type: 'success' });
                            var timeout = setTimeout(function () {
                                saveChanges();
                            }, 2200);
                            return function () { return clearTimeout(timeout); };
                        })
                            // @ts-ignore
                            .catch(function (error) {
                            addToast({ title: t('TS_core:NewUnitSettingCouldNotBeSaved'), text: '', type: 'error' });
                        })];
                case 3:
                    // @ts-ignore
                    _d.sent();
                    _d.label = 4;
                case 4:
                    if (!(roles !== userDetails.role)) return [3 /*break*/, 6];
                    // @ts-ignore
                    return [4 /*yield*/, changeUserRole(settings.role).then(function (response) {
                            newLoggedInProfileInfo.role = roles;
                            addToast({ title: t('TS_core:NewRoleSettingWasSaved'), text: '', type: 'success' });
                            var timeout = setTimeout(function () {
                                saveChanges();
                            }, 2200);
                            return function () { return clearTimeout(timeout); };
                        })
                            // @ts-ignore
                            .catch(function (error) {
                            addToast({ title: t('TS_core:NewRoleSettingCouldNotBeSaved'), text: '', type: 'error' });
                        })];
                case 5:
                    // @ts-ignore
                    _d.sent();
                    _d.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onClose = function () {
        navigate('/');
    };
    return (React.createElement(CustomModal, { id: "user-settings-modal", show: true, title: t("TS_core:UserSettings"), handleClose: onClose, actions: (React.createElement(React.Fragment, null,
            React.createElement("button", { disabled: saveDisabled, type: "button", className: "sdds-btn sdds-btn-sm sdds-btn-primary bttn", "cy-data": "saveButtonUserSettingsInCommon", onClick: handleSubmit }, t('TS_core:Save')),
            React.createElement("button", { type: "button", className: "sdds-btn sdds-btn-sm sdds-btn-secondary bttn", "cy-data": "cancelButtonUserSettingsInCommon", onClick: onClose }, t('TS_core:Cancel')))) },
        roleList.length === 0 && React.createElement(Spinner, null),
        roleList.length > 0 &&
            React.createElement("div", { className: "user-settings-modal" },
                React.createElement("div", { className: "userInformation" },
                    React.createElement("div", { className: "infoTitle" },
                        " ",
                        t("TS_core:userInformation")),
                    React.createElement("div", { className: "informations" },
                        React.createElement("div", { className: "details" },
                            React.createElement("div", { className: "name" },
                                React.createElement("p", null,
                                    t("TS_core:Name"),
                                    " : "),
                                React.createElement("p", null,
                                    t('TS_core:EmailAddress'),
                                    " : ")),
                            React.createElement("div", { className: "value" },
                                React.createElement("p", null,
                                    " ",
                                    settings.firstName,
                                    " ",
                                    settings.lastName),
                                React.createElement("p", null,
                                    " ",
                                    settings.email,
                                    " "))),
                        React.createElement("div", { className: "details" },
                            React.createElement("div", { className: "name" },
                                React.createElement("p", null,
                                    t("TS_core:Role"),
                                    " : ")),
                            React.createElement("div", { className: "value" },
                                React.createElement("p", null,
                                    " ",
                                    settings.role,
                                    " "))))),
                React.createElement("div", { className: "Settings" },
                    React.createElement("div", { className: "infoTitle" },
                        t("TS_core:CommunicatorSettings"),
                        " "),
                    React.createElement("div", { className: "informations" },
                        React.createElement("div", { className: "language dropdowns" },
                            React.createElement("p", null, t("TS_core:Language")),
                            React.createElement(Dropdown, { data: languageCode.sort(), placeholder: "Language", searchable: true, selectedValue: language, setSelectedValue: setLanguage, settingsType: "languageSettings" })),
                        (((_e = userDetails.permissions) === null || _e === void 0 ? void 0 : _e.developer) || ((_f = userDetails.permissions) === null || _f === void 0 ? void 0 : _f.trainer)) &&
                            React.createElement("div", { className: "role dropdowns" },
                                React.createElement("p", null,
                                    t("TS_core:Role"),
                                    " "),
                                React.createElement(Dropdown, { data: roleList, placeholder: "Role", selectedValue: roles, setSelectedValue: setRoles, settingsType: "roleSettings" }))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "unit" },
                            React.createElement("p", null,
                                t("TS_core:Unit"),
                                " "),
                            React.createElement("div", { className: "radioButtons  sdds-radio-button-group" },
                                React.createElement("div", { className: "sdds-radio-item" },
                                    React.createElement("input", { type: "radio", id: "rb-option-1", className: "sdds-form-input", value: "Metric", name: "Metric", checked: unit === 'Metric', onChange: function (e) { return setUnit(e.target.value); } }),
                                    React.createElement("label", { className: 'sdds-form-label', htmlFor: "rb-option-1" }, t('TS_core:MetricUnits'))),
                                React.createElement("div", { className: "sdds-radio-item" },
                                    React.createElement("input", { type: "radio", id: "rb-option-2", className: "sdds-form-input", value: "Imperial", name: "Imperial", checked: unit === 'Imperial', onChange: function (e) { return setUnit(e.target.value); } }),
                                    React.createElement("label", { className: 'sdds-form-label', htmlFor: "rb-option-2" }, t('TS_core:ImperialUnits')))))),
                    React.createElement(Toast, { toastQueue: toastQueue })))));
};
export default UserSettings;
